import {
  type File,
  IllustratorMimeTypes,
  isGifMimeType,
  isImageMimeType,
  TiffMimeTypes,
} from "@smartsuite/types";
import { Filelink, type Security, type TransformOptions } from "filestack-js";
import { env } from "./env";

/**
 * Construct url to include Content Disposition parameter to be able to download the file as attachment
 * this parameter can't be specified using filestack-js library, so it is added by editing url
 * https://www.filestack.com/docs/api/processing/#content-disposition
 *
 * @param url - filestack link to file
 * @param fileName - custom file name
 */
export const addContentDisposition = (
  url: string,
  fileName: string,
  type = "attachment",
): string => {
  const urlParts = url.split("/");
  const fileHandle = urlParts.pop();
  const encodedFileName = encodeURIComponent(fileName);
  return [...urlParts, `content=t:${type},f:"${encodedFileName}"`, fileHandle].join("/");
};

export const isUrl = (s: string): boolean => {
  return /^(http:\/\/|https:\/\/)/.test(s);
};

export const getUrl = (
  handle: string,
  security: Security,
  apiKey?: string,
  options?: TransformOptions,
): string => {
  const fileLink = new Filelink(handle, apiKey);
  fileLink.setCname(env.REACT_APP_FILESTACK_CNAME);
  fileLink.setUseValidator(false);
  fileLink.addTask("security", security);

  for (const key of Object.keys(options ?? {})) {
    // @ts-expect-error: strict mode enabled
    fileLink.addTask(key, options[key]);
  }
  return fileLink.toString();
};

export const isImageFile = (file: File): boolean => {
  return isImageMimeType(file.metadata?.mimetype) || isGifMimeType(file.metadata?.mimetype);
};

export const isFileRenderable = (file: File): boolean => {
  const mimetype = file.metadata?.mimetype || "";

  const isIllustratorType = IllustratorMimeTypes.includes(mimetype);
  const isTiffType = TiffMimeTypes.includes(mimetype);

  if (isIllustratorType || isTiffType) {
    return false;
  }

  return !file.file_type || isImageFile(file);
};
